import { Language } from '../../dto/language';
import { QuizStep, QuizMode } from '../../dto/user-words';
import { MakeReactive, noopMakeReactive } from '../make-reactive';
import { IQuizzService } from '../../services/i-quizz-service';

/**
 * Abstract loader for quiz data.
 * Framework-agnostic loader that manages quiz question loading.
 */
export abstract class IQuizLoader {
	protected constructor(
		protected readonly service: IQuizzService,
		protected readonly userId: string | undefined,
		protected readonly nativeLanguage: Language,
		protected readonly learnedLanguage: Language,
		protected readonly mode: QuizMode,
		protected readonly articleTranslationId?: string | undefined,
		protected readonly maxSteps?: number | undefined,
		protected readonly makeReactive: MakeReactive<unknown> = noopMakeReactive
	) {}

	abstract isLoading(): boolean;
	abstract loadQuiz(): Promise<void>;
	abstract get steps(): QuizStep[];
	abstract get error(): string;
	abstract clearCache(): void;
}

